'use client';

import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemPrice } from '@/app/(main)/_components/cart/cart-item/cart-item-price.component';
import { IconButton } from '@/components/ui/icon-button/icon-button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { CartItem } from '@/types/cart.types';

interface CartLaboratoryExamProps {
  item: CartItem;
  isDuplicated?: boolean;
  onRemove?: () => void;
}

export function CartLaboratoryExam({ item, isDuplicated, onRemove }: CartLaboratoryExamProps) {
  return (
    <div
      className="flex w-full items-start gap-3"
      data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM}
    >
      <div className="flex min-w-0 flex-1 flex-col">
        <Typography
          className={`text-base leading-6 ${isDuplicated ? 'text-warning-700' : 'text-gray-700'}`}
          data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM_NAME}
        >
          {item.procedure.name}
        </Typography>

        <CartItemPrice item={item} priceDataTestId={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM_PRICE} />
      </div>

      {onRemove && (
        <IconButton
          size="lg"
          icon={faTrash}
          label={`Remover ${item.procedure.name}`}
          onClick={onRemove}
          iconClassName="text-green-500 group-active:text-green-600"
          data-testid={DataTestIdEnum.CART_LABORATORY_GROUP_EXAM_REMOVE_BUTTON}
        />
      )}
    </div>
  );
}
